import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import PartnersPage from './pages/PartnersPage';
import SolutionsPage from './pages/SolutionsPage';
import FestivalsPage from './pages/FestivalsPage';
import AboutPage from './pages/AboutPage';
import FestivalsDirectoryPage from './pages/FestivalsDirectoryPage';
import FestivalDetailPage from './pages/FestivalDetailPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import SupportPage from './pages/SupportPage';
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/solutions" element={<SolutionsPage />} />
        <Route path="/festivals" element={<FestivalsPage />} />
        <Route path="/festivalkalender" element={<FestivalsDirectoryPage />} />
        <Route path="/festival-kalender" element={<FestivalsDirectoryPage />} />
        <Route path="/festival/:id" element={<FestivalDetailPage />} />
        <Route path="/partners" element={<PartnersPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="/privacy-policy/" element={<PrivacyPolicyPage />} />
        <Route path="/support" element={<SupportPage />} />
        <Route path="/support/" element={<SupportPage />} />
      </Routes>
    </Router>
  );
}

export default App;
